import styled from 'styled-components'
import { Form } from 'formik'

import theme from 'theme_'
import { StyledInputError } from 'components/Input/styles'
import { BaseText } from 'components/Typography/Base'
import { Font16, Regular } from 'components/Typography/Labels'

export const StyledPaymentIcons = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing.md};
`

export const StyledBrandIcon = styled.img`
  margin: 0 5px;
`

export const StyledAddPaymentMethodForm = styled(Form)<{
  $isStandalone?: boolean
}>`
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: ${(p) => (p.$isStandalone ? theme.spacing.xlarge : theme.spacing.sm)}
    0;

  input {
    width: 100%;
  }
`

export const StyledMakeDefaultToggle = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${theme.spacing.sm} 0 ${theme.spacing.s};
`

export const StyledMakeDefaultText = styled(Regular)`
  color: ${theme.colors.menuDark};
`

export const StyledAddPaymentInner = styled.div`
  position: relative;
  z-index: 1;
`

export const StyledExpiryCvc = styled.div`
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
`

export const StyledExpiryWrap = styled.div`
  width: calc(50% - 6px);
`

export const StyledCountryPostal = styled.div`
  display: inline-flex;
  width: 100%;
  margin-top: ${theme.spacing.s};
`

export const StyledCountryWrap = styled.div`
  width: 66%;
  flex-shrink: 0;
  margin-right: ${theme.spacing.s};
`

export const StyledChargesInfo = styled(BaseText)`
  color: ${theme.colors.darkeyGrey};
`

export const StyledAddPaymentFormError = styled(StyledInputError)``

export const StyledFailedScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StyledFailedScreenError = styled(StyledInputError)`
  ${Font16};
  margin: ${theme.spacing.md} 0 ${theme.spacing.lg};
`

export const StandalonePaymentMethodSubmit = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${theme.spacing.xxl};
`

export const stripeElementsCommonInputStyle = {
  base: {
    fontSize: '16px',
    color: theme.colors.menuDark,
    '::placeholder': {
      color: theme.colors.disabledGrey,
    },
    fontFamily: theme.fonts.base,
    fontWeight: 100,
  },
  invalid: {
    color: theme.colors.error,
  },
  fonts: [
    {
      cssSrc: 'https://fonts.googleapis.com/css?family=Raleway',
    },
  ],
}
